export default class FinesseProductForm extends HTMLElement {
  id: string = ''

  inputId: HTMLElement | null = null
  form: HTMLElement | null = null
  select: HTMLElement | null = null

  static get observedAttribute() {
    return ['id']
  }

  constructor() {
    super()

    this.id = this.getAttribute('id') || ''
    this.inputId = this.querySelector('input[name="id"]')
    this.form = this.querySelector('form[data-product-form]')
    this.select = this.querySelector('select[name="size"]')

    if (this.form) {
      // this.form.addEventListener('submit', this.handleSubmit.bind(this))
    }

    if (this.select) {
      this.select.addEventListener('change', this.handleSizeChange.bind(this))
    }
  }

  handleSizeChange(evt: Event) {
    evt.preventDefault()

    const target = evt.target as HTMLSelectElement
    const id = target.value

    if (this.inputId) {
      this.inputId.setAttribute('value', id)
    }
  }
}

customElements.define('finesse-product-form', FinesseProductForm)
